import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { Lightbulb, Building2, Leaf, Heart } from "lucide-react";

const Themes: React.FC = () => {
	const themes = [
		{
			id: "local-business",
			title: "地域ビジネス",
			description: "地域の商店や事業者が抱える課題の解決",
			icon: Building2,
			examples: [
				"商店街のデジタル化支援",
				"観光客向けサービス",
				"地域特産品のPR",
			],
		},
		{
			id: "environment",
			title: "環境・防災",
			description: "環境保護や防災に関する課題の解決",
			icon: Leaf,
			examples: ["ゴミ削減・リサイクル", "災害情報の共有", "環境モニタリング"],
		},
		{
			id: "community",
			title: "コミュニティ",
			description: "地域コミュニティの活性化",
			icon: Heart,
			examples: [
				"高齢者見守りシステム",
				"地域イベント活性化",
				"世代間交流促進",
			],
		},
		{
			id: "innovation",
			title: "地域イノベーション",
			description: "新しい技術を活用した地域課題の解決",
			icon: Lightbulb,
			examples: ["スマートシティ化", "教育のデジタル化", "地域DX推進"],
		},
	];

	return (
		<section className="py-16 bg-gray-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<h2 className="text-3xl font-bold mb-4 text-center">テーマ領域</h2>
				<p className="text-gray-600 text-center mb-12">
					以下のテーマに関連する課題解決を目指します
				</p>
				<div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
					{themes.map((theme) => (
						<Card key={theme.id}>
							<CardHeader>
								<div className="flex items-center gap-3">
									<theme.icon className="w-6 h-6 text-purple-600" />
									<CardTitle>{theme.title}</CardTitle>
								</div>
								<CardDescription>{theme.description}</CardDescription>
							</CardHeader>
							<CardContent>
								<ul className="list-disc list-inside space-y-2 text-sm text-gray-600">
									{theme.examples.map((example) => (
										<li key={example}>{example}</li>
									))}
								</ul>
							</CardContent>
						</Card>
					))}
				</div>
			</div>
		</section>
	);
};

export default Themes;
